// scale video elements to max-size within parent element
function resizeVideo( $video = false, availableWidth = false, availableHeight = false ) {
    if ( !( $video && availableWidth && availableHeight ) ) return false;

    let videoWidth = availableHeight / 0.5625,
        videoHeight;

    if ( videoWidth > availableWidth ) {
        $video.css({
            'width': videoWidth,
            'height': availableHeight
        });
    } else {
        videoHeight = availableWidth * 0.5625;

        $video.css({
            'width': availableWidth,
            'height': videoHeight
        });
    }
}

$('.player--dynamic-resize').each(function() {
    let $wrapper = $(this),
        $player = $('.player__inner', this);

    resizeVideo($player, $wrapper.outerWidth(), $wrapper.outerHeight());

    $(window).on('resize', function () {
        resizeVideo($player, $wrapper.outerWidth(), $wrapper.outerHeight());
    });
});